import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { reducer as authReducer} from "./auth/reducer";

const rootReducer = combineReducers({
    auth: authReducer
})

export const store = createStore(rootReducer, compose(applyMiddleware(thunk) ));